/* global google */
/* global jQuery */
/* global require */
angular
  .module('detailerBlacklist')
  .component('detailerBlacklist', {
    template: require('./detailer-blacklist.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'uiGmapGoogleMapApi', 'CenterInfo',
      function DetailerBlacklistController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        const APIURL = envService.read('apiUrl');
        $rootScope.mainmenu = 'members';
        $rootScope.menu = 'detailerBlacklist';
        this.doLogout = $rootScope.gLogout;
        this.loginMember = AuthService.loginMember();
        this.moveToWashHistory = $rootScope.moveToWashHistory;
        this.showEmployeeView = $rootScope.gShowEmployeeView;
        this.showUserView = $rootScope.gShowUserView;

        this.query = '';
        this.paging = (page) => {
          $resource(`${APIURL}/admin/blacklist/employees`).get({ page: page - 1 }).$promise
            .then((data) => {
              this.blacklist = data.blacklist;
              this.totalCount = data.totalCount;
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.delete = (id) => {
          if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
            return;
          }
          $resource(`${envService.read('apiUrl')}/admin/blacklist/employees/${id}`).delete().$promise
            .then(() => {
              this.blacklist = this.blacklist.filter(blacklistUser => blacklistUser.ID !== id);
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.add = () => {
          const payload = { tbUserId: this.newuser.ID, tbUserIdEmployee: this.newEmployeTbUserId };
          $resource(`${envService.read('apiUrl')}/admin/blacklist/employees`).save(payload).$promise
            .then((data) => {
              this.blacklist = data.blacklist;
              this.totalCount = data.totalCount;
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        $resource(`${APIURL}/admin/employees`).get({ count: 10000, include_unregister: false }, (data) => {
          this.employees = data.users;
          console.log(data);
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
        // 사용자 검색
        this.openUsers = () => {
          this.userSearch = { query: '', result: [] };
          jQuery('#modal-users').modal('show');
        };
        this.searchUsers = () => {
          $resource(`${APIURL}/admin/users`).get({ q: this.userSearch.query, count: -1 }, (data) => {
            this.userSearch.result = data.users;
            console.log(data);
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        this.selectUser = (user) => {
          this.newuser = user;
          jQuery('#modal-users').modal('hide');
        };
        this.paging(1);
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/detailer-blacklist/detailer-blacklist.component.js